import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { InputForm } from '@/components/ui/inputForm';

const InputEmail = ({
  name,
  placeholder,
  icon,
  className,
  isRequired,
  label,
  isDisabled,
  autocomplete = null,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });
  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  };

  return (
    <div className={`${className}`}>
      <FormField
        name={name}
        control={control}
        rules={{
          required: isRequired ? t('required') : '',
          validate: (value) => {
            if (value && !isValidEmail(value)) {
              return t('invalidEmail');
            }
            return true;
          },
        }}
        disabled={isDisabled}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <FormControl>
              <InputForm
                autocomplete={autocomplete}
                type='email'
                error={errors[name]}
                placeholder={placeholder}
                icon={icon}
                isRequired={isRequired}
                isDisabled={isDisabled}
                label={label}
                {...field}
              />
            </FormControl>
            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      />
    </div>
  );
};

export default InputEmail;
